import React from 'react'
import './SearchForm.scss'

// This just formats SearchInputField, SearchCheckbox, and SearchSubmitButton
// into a responsive bar // stack.
const SearchForm = ({ title, children, forceStacked = false }) => {
  const preventFormSubmission = (e) => {
    e.preventDefault()
  }
  return (
    <form
      onSubmit={preventFormSubmission}
      className={`SearchForm ${forceStacked ? 'force-stacked' : ''}`}
    >
      {title ? (
        <h2>{title}</h2>
      ) : (
        <div>
          {' '}
          {/* need an empty div to take the title's place in the grid. */}{' '}
        </div>
      )}
      {children}
    </form>
  )
}

export default SearchForm
